import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {http} from 'hiya-common/src/utils/axios'

// 独立日活动 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92468665
export const ind_get_reward = createAsyncThunk(
  'ind_get_reward',
  async (arg: {stage_no: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'err_msg'>>
    >(
      '/live/activity/ind_get_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    const {err_msg = ''} = resp.data.data
    if (err_msg) {
      onlyToast(err_msg)
    }
    return resp.data.data
  }
)

export interface GiftItemType {
  name: string
  icon: string
  num: string
  type: number
}

interface InitialStateType {
  // 奖励获取
  list?: Array<GiftItemType>
  err_msg?: string
}

const initialState: InitialStateType = {}

export const IdsIndependDayModalSlice = createSlice({
  name: 'IdsIndependDayModal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 领取页面相关
    builder.addCase(ind_get_reward.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default IdsIndependDayModalSlice.reducer
export const IdsIndependDayModalActions = IdsIndependDayModalSlice.actions
